import {SET_BACKGROUND_COLOR} from "../constants/action-types";
import Mediator from "../services/Mediator";
import {changeBgColorForOtherSides} from "./change-bg-color-for-other-sides";

export const setBackgroundColor = (color, forAllSides) => (dispatch) => {
  dispatch({
    type: SET_BACKGROUND_COLOR,
    payload: {
      color
    }
  });
  Mediator.setBackgroundColor(color);
  if (forAllSides) {
    dispatch(changeBgColorForOtherSides(color));
  }
};
